<template>
<svg viewBox="0 0 20 20" :fill="useCurrentColor ? 'currentColor' : '#000'" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-fill-search-data`]" width="1em" height="1em" v-bind="$attrs"><path d="M15.751 11.2954C17.5479 11.2956 19.0047 12.7523 19.0049 14.5493C19.0049 15.0834 18.8745 15.587 18.6465 16.0317L19.3545 16.7397C19.745 17.1303 19.745 17.7633 19.3545 18.1538C18.964 18.5441 18.3309 18.5443 17.9404 18.1538L17.2324 17.4458C16.7879 17.6737 16.2848 17.8041 15.751 17.8042C13.9538 17.8042 12.4961 16.3465 12.4961 14.5493C12.4963 12.7522 13.9539 11.2954 15.751 11.2954ZM1.63184 11.7739C1.63214 13.8202 5.1791 15.5941 9.4082 15.5942H9.81836C9.9548 16.549 10.2269 17.504 10.7725 18.186H9.4082C5.04249 18.1859 1.63184 16.4122 1.63184 14.3657V11.7739ZM1.63184 7.4077C1.63184 9.59058 5.04249 11.2282 9.4082 11.3647C9.69541 11.3737 10.7775 11.3644 11.0459 11.228C10.5002 11.9101 10.0906 12.8649 9.9541 13.8198H9.4082C5.0428 13.8197 1.63232 12.1831 1.63184 10.0005V7.4077ZM9.4082 1.81395C11.4706 1.81395 13.4488 2.21673 14.9072 2.93309C16.3657 3.64951 17.1855 4.62109 17.1855 5.63426C17.1855 6.64737 16.3656 7.61905 14.9072 8.33543C13.4488 9.05176 11.4706 9.45457 9.4082 9.45457C7.34582 9.45452 5.36751 9.05181 3.90918 8.33543C2.45102 7.61907 1.63192 6.6473 1.63184 5.63426C1.63184 4.62119 2.45102 3.64949 3.90918 2.93309C5.36751 2.21672 7.34582 1.814 9.4082 1.81395Z"/></svg>
</template>
<script>

export default {
  name: 'IconFillSearchData',
  props: {
    prefix: {
        type: String,
        default: 'sc',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
